
<!-- <section class="section-title">

  <h1 i18n="@@dashboard_welcome_title">Benvenuto</h1>
  <p class="padding-left-150 padding-right-150" i18n="@@dashboard_welcome_text">Benvenuto nell'Area Amministrativa Web di 1Control. Da qui puoi gestire i tuoi dispositivi, creare e modificare condivisioni, visualizzare lo storico accessi e gestire tutti i servizi che hai attivato.</p>

</section> -->

<!-- <app-devices></app-devices> -->

<app-loading-screen #loader></app-loading-screen>
